export const parseOfferDateValue = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const parsedFromNumber = new Date(value);
    return Number.isNaN(parsedFromNumber.getTime()) ? null : parsedFromNumber;
  }

  const rawValue = String(value).trim();
  if (!rawValue) return null;

  const directDate = new Date(rawValue);
  if (!Number.isNaN(directDate.getTime())) {
    return directDate;
  }

  const normalizedIsoDate = new Date(rawValue.replace(" ", "T"));
  return Number.isNaN(normalizedIsoDate.getTime()) ? null : normalizedIsoDate;
};

export const getOfferRemainingSeconds = ({
  endTime = null,
  toDate,
  remainingSeconds = null,
  loadedAt = null,
  now = Date.now(),
}) => {
  const parsedEndTime = parseOfferDateValue(endTime ?? toDate);
  if (parsedEndTime) {
    return Math.max(0, Math.floor((parsedEndTime.getTime() - now) / 1000));
  }

  const normalizedRemainingSeconds = Number(remainingSeconds);
  if (Number.isFinite(normalizedRemainingSeconds)) {
    const elapsedSeconds = loadedAt
      ? Math.max(0, Math.floor((now - loadedAt) / 1000))
      : 0;

    return Math.max(0, normalizedRemainingSeconds - elapsedSeconds);
  }

  return null;
};

export const formatOfferCountdown = (
  totalSeconds,
  { alwaysShowDays = false } = {},
) => {
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) {
    return "Offer expired";
  }

  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (alwaysShowDays || days > 0) {
    return `Ends in ${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  return `Ends in ${hours}h ${minutes}m ${seconds}s`;
};
